import { userRequest } from '../requestMethods';
import config from '../config';

const DOMAIN = config.REACT_APP_SERVER_DOMAIN;

export const getTypes = async () => {
    return userRequest.get(`${DOMAIN}/api/types`);
  };

export const getArticle = async () => {
    return userRequest.get(`${DOMAIN}/api/types/article`);
  };

export const getArticleOneV = async (idArt) => {
    return userRequest.get(`${DOMAIN}/api/types/articleOneV?id_article=${idArt}`);
  };

export const getArticleOne = async (idArt, idFour) => {
    return userRequest.get(`${DOMAIN}/api/types/articleOne?id_article=${idArt}&id_fournisseur=${idFour}`);
  };

export const putArticle = async (id, data) => {
    return userRequest.put(`${DOMAIN}/api/types/article?id_article=${id}`, data);
  };

export const getBatimentCount = async () => {
    return userRequest.get(`${DOMAIN}/api/types/batimentcount`);
  };

  export const getBatiment = async () => {
    return userRequest.get(`${DOMAIN}/api/types/batiment`);
  };

  export const getBatimentOne = async (id) => {
    return userRequest.get(`${DOMAIN}/api/types/batiment/one?id=${id}`);
  };

  export const postBatiment = async (data) => {
    return userRequest.post(`${DOMAIN}/api/types/batiment`, data);
  };

  export const putBatiment = async (id,data) => {
    return userRequest.put(`${DOMAIN}/api/types/batiment/update?id_batiment=${id}`, data);
  };

  export const putDeleteBatiment = async (id) => {
    return userRequest.put(`${DOMAIN}/api/types/batiment/update_delete?id=${id}`);
    };

  //Categorie
  export const getCategorie = async () => {
    return userRequest.get(`${DOMAIN}/api/types/categorie`);
  };

  export const getCategorieOne = async (id) => {
    return userRequest.get(`${DOMAIN}/api/types/categorie/one?id=${id}`);
  };

  export const postCategorie = async (data) => {
    return userRequest.post(`${DOMAIN}/api/types/categorie`, data);
  };

  export const putCategorie = async (id,data) => {
    return userRequest.put(`${DOMAIN}/api/types/categorie_put?id=${id}`, data);
  };

  //Activité
  export const getActivite = async () => {
    return userRequest.get(`${DOMAIN}/api/types/activite`);
  };

  export const postActivite = async (data) => {
    return userRequest.post(`${DOMAIN}/api/types/activite`, data);
  };

  //TYPE CAT TACHE
export const getCorpsMetier = async () => {
    return userRequest.get(`${DOMAIN}/api/types/corps_metier`);
  };

export const getCorpsMetierOne = async (id) => {
    return userRequest.get(`${DOMAIN}/api/types/corps_metier/one?id_corps=${id}`);
  };

export const postCorpsMetier = async (data) => {
    return userRequest.post(`${DOMAIN}/api/types/corps_metier`, data);
  };

export const putCorpsMetier = async (id, data) => {
    return userRequest.get(`${DOMAIN}/api/types/corps_metier_update?id=${id}`,data);
  };

export const getCatTache = async () => {
    return userRequest.get(`${DOMAIN}/api/types/cat_tache`);
  };

export const getCatTacheOne = async (id) => {
    return userRequest.get(`${DOMAIN}/api/types/cat_tache/one?id=${id}`);
  };

export const postCatTache = async (data) => {
  return userRequest.post(`${DOMAIN}/api/types/cat_tache/post`, data);
};

export const putCatTache = async (id, data) => {
  return userRequest.put(`${DOMAIN}/api/types/cat_tache_put?id=${id}`,data);
};

//TYPE BINS
export const getTypeBin = async () => {
  return userRequest.get(`${DOMAIN}/api/types/type_bin`);
};

export const getStatutBin = async () => {
  return userRequest.get(`${DOMAIN}/api/types/statut_bin`);
};

//Status batiment
export const getStatus_batiment = async () => {
  return userRequest.get(`${DOMAIN}/api/types/status_batiment`);
};